import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';
import useGetUser from 'hooks/useGetUser';

const useGetCurrentEntity = () => {
    const currentEntityId = useGetCurrentEntityId();
    const user = useGetUser();
    const currentEntity = (user?.entities ?? []).find((entity) => entity.id === currentEntityId);
    return currentEntity;
};

export default useGetCurrentEntity;
